import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { BinderWizardService } from '../services/sections/binder/binder-wizard.service';
import { BinderDetails } from '../models/binder/binder-details.model';

@Injectable({
	providedIn: 'root'
})
export class BinderDetailsResolver implements Resolve<Observable<BinderDetails>> {

	constructor(
		private router: Router,
		private binderWizardService: BinderWizardService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		return this.binderWizardService
			.getBinderDetails(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
